<template>
  <el-dialog 
    title="创建算力规格" 
    :visible.sync="dialogVisible" 
    width="80%" 
    @close="resetForm" 
    :close-on-click-modal="false"
  >
    <div class="form-container">
      <el-form :model="createForm" :rules="rules" ref="createForm" label-width="120px" size="small">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="名称：" prop="title">
              <el-input v-model="createForm.title" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="资源类型：" prop="compute_type_id">
              <el-select 
                v-model="createForm.compute_type_id" 
                placeholder="请选择资源类型" 
                style="width: 100%;"
                :loading="computeTypeLoading"
              >
                <el-option 
                  v-for="item in computeTypeOptions" 
                  :key="item.id" 
                  :label="item.name" 
                  :value="item.id"
                >
                  <div class="compute-type-option">
                    <!-- <img 
                      :src="`https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=${encodeURIComponent(item.name + ' GPU server')}&image_size=square`" 
                      :alt="item.name"
                      class="compute-type-image"
                    /> -->
                    <span class="compute-type-name">{{ item.name }}</span>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="提供商：" prop="provider_name">
              <el-select 
                v-model="createForm.provider_name" 
                placeholder="请选择提供商" 
                style="width: 100%;" 
                :loading="loading"
                @change="handleProviderChange"
              >
                <el-option 
                  v-for="item in providerOptions" 
                  :key="item.provider" 
                  :label="item.provider" 
                  :value="item.provider"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="可用区：" prop="region">
              <el-select 
                v-model="createForm.region" 
                placeholder="请选择可用区" 
                style="width: 100%;"
                :loading="azloading"
                @change="handleRegionChange"
              >
                <el-option 
                  v-for="item in azOptions" 
                  :key="item.az_name" 
                  :label="item.az_name" 
                  :value="item.az_name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-form-item label="提供商id：" prop="provider_id" style="display: none;">
          <el-input v-model="createForm.provider_id" placeholder="提供商id"></el-input>
        </el-form-item>
        <el-form-item label="可用区id：" prop="region_id" style="display: none;">
          <el-input v-model="createForm.region_id" placeholder="可用区id"></el-input>
        </el-form-item>
        <el-form-item label="是否纳管：" prop="ext_01" style="display: none;">
          <el-input v-model="createForm.ext_01" placeholder="是否纳管"></el-input>
        </el-form-item>
        <el-form-item label="资源链接：" prop="ext_04" style="display: none;">
          <el-input v-model="createForm.ext_04" placeholder="资源链接"></el-input>
        </el-form-item>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="设备数量：" prop="device_quantity">
              <el-input v-model="createForm.device_quantity" type="number" placeholder="请输入设备数量"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="CPU：" prop="cpu">
              <el-input v-model="createForm.cpu" placeholder="请输入CPU"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="内存(GB)：" prop="memory_gb">
              <el-input v-model="createForm.memory_gb" placeholder="请输入内存"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="GPU：" prop="gpu">
              <el-input v-model="createForm.gpu" placeholder="请输入GPU"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="GPU数量：" prop="gpu_count">
              <el-input v-model="createForm.gpu_count" type="number" placeholder="请输入GPU数量"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="GPU内存(GB)：" prop="gpu_memory_gb">
              <el-input v-model="createForm.gpu_memory_gb" placeholder="请输入GPU内存"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="PCIe版本：" prop="pcie_version">
              <el-input v-model="createForm.pcie_version" placeholder="请输入PCIe版本"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="存储：" prop="storage">
              <el-input v-model="createForm.storage" placeholder="请输入存储"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="计算网络：" prop="compute_network">
              <el-input v-model="createForm.compute_network" placeholder="请输入计算网络"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="存储网络：" prop="storage_network">
              <el-input v-model="createForm.storage_network" placeholder="请输入存储网络"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="业务网络：" prop="business_network">
              <el-input v-model="createForm.business_network" placeholder="请输入业务网络"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="价格：" prop="price">
              <el-input v-model="createForm.price" type="number" placeholder="请输入价格"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="价格单位：" prop="price_unit">
              <el-select v-model="createForm.price_unit" placeholder="请选择价格单位">
                <el-option label="台·日" value="1"></el-option>
                <!-- <el-option label="卡·时" value="2"></el-option>
                <el-option label="T·月" value="3"></el-option>
                <el-option label="台·月" value="4"></el-option> -->
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否首页推荐：" prop="is_home_recommended">
              <el-select v-model="createForm.is_home_recommended" placeholder="请选择">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="是否发布：" prop="is_published">
              <el-select v-model="createForm.is_published" placeholder="请选择">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序：" prop="sort_order">
              <el-input v-model="createForm.sort_order" type="number" placeholder="请输入排序"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="标签：" prop="tags">
              <el-input v-model="createForm.tags" placeholder="请输入标签"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-form-item label="产品介绍：" prop="product_intro">
          <el-input v-model="createForm.product_intro" type="textarea" placeholder="请输入产品介绍"></el-input>
        </el-form-item>
        <el-form-item label="应用场景：" prop="application_scenarios">
          <el-input v-model="createForm.application_scenarios" type="textarea" placeholder="请输入应用场景"></el-input>
        </el-form-item>
        <el-form-item label="产品规格：" prop="product_spec">
          <el-input v-model="createForm.product_spec" type="textarea" placeholder="请输入产品规格"></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-input v-model="createForm.remark" type="textarea" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="dialogVisible = false">取消</el-button>
      <el-button size="small" type="primary" @click="submitForm('createForm')">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'CreateComputeProduct',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      azloading: false,
      computeTypeLoading: false,
      providerOptions: [],
      azOptions: [],
      computeTypeOptions: [],
      createForm: {
        title: '',
        compute_type_id: '',
        cpu: '',
        memory_gb: '',
        gpu: '',
        gpu_count: 0,
        gpu_memory_gb: '',
        pcie_version: '',
        storage: '',
        compute_network: '',
        storage_network: '',
        business_network: '',
        price: 0,
        price_unit: '',
        is_home_recommended: '',
        is_published: '',
        sort_order: '',
        tags: '',
        provider_name: '',
        provider_id: '',
        region: '',
        region_id: '',
        ext_01: 0,
        ext_04: 'https://baremetal.ltaidc.com/resources?specId={{id}}',
        device_quantity: 0,
        product_intro: '',
        application_scenarios: '',
        product_spec: '',
        remark: ''
      },
      rules: {
        title: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        compute_type_id: [
          { required: true, message: '请选择资源类型', trigger: 'change' }
        ],
        gpu: [
          { required: true, message: '请输入GPU', trigger: 'blur' }
        ],
        gpu_count: [
          { required: true, message: '请输入GPU数量', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入价格', trigger: 'blur' }
        ],
        price_unit: [
          { required: true, message: '请输入价格单位', trigger: 'blur' }
        ],
        is_home_recommended: [
          { required: true, message: '请选择是否首页推荐', trigger: 'change' }
        ],
        is_published: [
          { required: true, message: '请选择上架状态', trigger: 'change' }
        ],
        sort_order: [
          { required: true, message: '请输入排序值', trigger: 'blur' }
        ],
        provider_name: [
          { required: true, message: '请选择提供商', trigger: 'blur' }
        ],
        provider_id: [
          { required: true, message: '请选择提供商', trigger: 'blur' }
        ],
        region: [
          { required: true, message: '请选择可用区', trigger: 'blur' }
        ],
        region_id: [
          { required: true, message: '请选择可用区', trigger: 'blur' }
        ],
        ext_01: [
          { required: true, message: '请选择是否纳管', trigger: 'change' }
        ],
        device_quantity: [
          { required: true, message: '请输入设备数量', trigger: 'blur' }
        ]
      }
    };
  },
  mounted() {
    this.fetchProviders();
    this.fetchComputeTypes();
  },
  methods: {
    openDialog(providerName, zonesName) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.createForm) {
          this.$refs.createForm.clearValidate();
        }
        // 如果传入了提供商和可用区信息，自动填充
        if (providerName) {
          this.createForm.provider_name = providerName;
          this.fetchAzByProvider(providerName).then(() => {
            if (zonesName) {
              this.createForm.region = zonesName;
            }
          });
        }
      });
    },

    resetForm() {
      if (this.$refs.createForm) {
        this.$refs.createForm.resetFields();
      }
    },

    fetchProviders() {
      this.loading = true;
      this.$axios.get('/api-30216/api/regions')
          .then(res => {
            if (res.code === 200 && Array.isArray(res.data)) {
              this.providerOptions = res.data.map(item => ({
                provider: item.provider,
                provider_id: item.id
              }));
            } else {
              this.$message.error(res.message || '加载提供商失败');
              this.providerOptions = [];
            }
          })
        .catch(err => {
          this.$message.error('请求失败，请检查网络');
          console.error(err);
          this.providerOptions = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    fetchComputeTypes() {
      this.computeTypeLoading = true;
      this.$axios.get('/api-30216/api/compute-types', {
        params: {
          page: 1,
          pageSize: 100 // Get enough options
        }
      })
        .then(res => {
          if (Array.isArray(res.data)) {
            this.computeTypeOptions = res.data.map(item => ({
              id: item.id,
              name: item.name
            }));
          } else {
            this.$message.error(res.message || '加载资源类型失败');
            this.computeTypeOptions = [];
          }
        })
        .catch(err => {
          this.$message.error('请求失败，请检查网络');
          console.error(err);
          this.computeTypeOptions = [];
        })
        .finally(() => {
          this.computeTypeLoading = false;
        });
    },

    fetchAzByProvider(providerName) {
      return new Promise((resolve, reject) => {
        this.azloading = true;
        this.azOptions = [];

        if (!providerName) {
          this.azloading = false;
          resolve();
          return;
        }

        const url = `/api-30216/api/zones?provider=${encodeURIComponent(providerName)}`;

        this.$axios.get(url)
          .then(res => {
            if (res.code === 200 && Array.isArray(res.data)) {
              this.azOptions = res.data.map(item => ({
                az_name: item.name,
                az_id: item.id,
                ext_01: item.ext_01
              }));
            } else {
              this.$message.warning(res.message || '该提供商下暂无可用区');
              this.azOptions = [];
            }
            resolve();
          })
          .catch(err => {
            this.$message.error('获取可用区失败，请检查网络或联系管理员');
            console.error(err);
            this.azOptions = [];
            reject(err);
          })
          .finally(() => {
            this.azloading = false;
          });
      });
    },

    handleProviderChange(providerName) {
      this.createForm.region = '';
      this.createForm.region_id = '';
      const selectedProvider = this.providerOptions.find(item => item.provider === providerName);
      if (selectedProvider) {
        this.createForm.provider_id = selectedProvider.provider_id || '';
      }
      this.fetchAzByProvider(providerName);
    },

    handleRegionChange(regionName) {
      const selectedRegion = this.azOptions.find(item => item.az_name === regionName);
      if (selectedRegion) {
        this.createForm.region_id = selectedRegion.az_id || '';
        this.createForm.ext_01 = selectedRegion.ext_01 || '0';
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return;

        // 深拷贝表单数据
        const postData = { ...this.createForm };
        
        // 设置关联类型为1（裸金属）
        postData.relation_type = 1;
        
        // 手动将数字字段转换为数字类型
        postData.compute_type_id = Number(postData.compute_type_id);
        postData.gpu_count = Number(postData.gpu_count);
        postData.price = Number(postData.price);
        postData.price_unit = Number(postData.price_unit);
        postData.is_home_recommended = Number(postData.is_home_recommended);
        postData.is_published = Number(postData.is_published);
        postData.sort_order = Number(postData.sort_order);
        postData.device_quantity = Number(postData.device_quantity);

        this.$axios.post('/api-30216/api/compute-products', postData, {
          headers: { 'Content-Type': 'application/json' },
          transformRequest: [(data) => {
            return JSON.stringify(data);
          }]
        })
          .then(res => {
            const responseData = res.data || res;
            if (responseData.code === 200) {
              this.$message.success(responseData.message || '创建成功');
              this.dialogVisible = false;
              this.$emit('success');
            } else {
              this.$message.error(responseData.message || '创建失败');
            }
          })
          .catch(err => {
            let errorMessage = '请求失败';
            if (err && err.response && err.response.data && err.response.data.message) {
              errorMessage = err.response.data.message;
            } else if (err && err.message) {
              errorMessage = err.message;
            }
            this.$message.error(errorMessage);
            console.error('提交错误详情:', err);
          });
      });
    }
  }
};
</script>

<style scoped>
.form-container {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 10px;
}
.form-container::-webkit-scrollbar {
  width: 6px;
}
.form-container::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 3px;
}
.el-dialog .el-form-item {
  margin-bottom: 18px;
}
.dialog-footer {
  text-align: right;
}

.compute-type-option {
  display: flex;
  align-items: center;
  padding: 8px 0;
}

.compute-type-image {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  margin-right: 12px;
  object-fit: cover;
}

.compute-type-name {
  font-size: 14px;
  font-weight: 500;
}
</style>